var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0"},[(_vm.condition)?_c('IconCheck',{staticClass:"active"}):_c('IconCloseCircle',{staticClass:"danger"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }